import { Enums } from '../enums';

export const parseSettlement = message => {
  const hexMessage = message.toString('hex');
  const fields = hexMessage.split('2c').map(field => {
    return Buffer.from(field, 'hex').toString();
  });

  if (fields[0] !== '04') {
    throw new Error('Settlement tag is not 04, wrong tag or out of order fields.');
  }

  const response = {};

  fields.forEach((value, i) => {
    const Enum = Enums.responses.settlement[i];
    if (!Enum) {
      response.unknown = value;
      return;
    }
    const { field } = Enum;
    logger.debug(`marshal - parseSettlement - parsing field [${field}] with value [${value}]`);
    response[field] = value;
  });

  return response;
};
